export default {
    // 任务查询接口
    listJobsInfoPage(params, response) {
        return window.vue.$apiAxios.postRequestBody('/timedTaskManager/findJob', params, response);
    },
    // 添加
    addJob(params, response) {
        return window.vue.$apiAxios.postRequestBody('/timedTaskManager/addJob', params, response);
    },
    // 删除
    deleteJob(params, response) {
        return window.vue.$apiAxios.get('/timedTaskManager/deleteJob', params, response);
    },
    // 批量删除接口
    deleteBatchGroup(params, response) {
        return window.vue.$apiAxios.postRequestBody('/timedTaskManager/deleteBatchGroup', params, response);
    },
    // 修改
    modifyJob(params, response) {
        return window.vue.$apiAxios.postRequestBody('/timedTaskManager/modifyJob', params, response);
    },
    // 启动任务接口
    startJob(params, response) {
        return window.vue.$apiAxios.postRequestBody('/timedTaskManager/startJob', params, response);
    },
    // 批量启动接口
    startJobBatch(params, response) {
        return window.vue.$apiAxios.postRequestBody('/timedTaskManager/startJobBatch', params, response);
    },
    // 启动任务接口
    stopJob(params, response) {
        return window.vue.$apiAxios.postRequestBody('/timedTaskManager/stopJob', params, response);
    },
    // 停止任务接口
    stopJobBatch(params, response) {
        return window.vue.$apiAxios.postRequestBody('/timedTaskManager/stopJobBatch', params, response);
    },
    // 检测任务名称
    chackJobNameExist(params, response) {
        return window.vue.$apiAxios.get('/timedTaskManager/chackJobNameExist', params, response);
    },
    // 检测任务名称
    countJobByState(params, response) {
        return window.vue.$apiAxios.get('/timedTaskManager/countJobByState', params, response);
    },
    // 运行日志查看
    findJoRunLog(params, response) {
        return window.vue.$apiAxios.postRequestBody('/timedTaskManager/findJobRunLog', params, response);
    },
    // 检测cron表达式
    checkCron(params, response) {
        return window.vue.$apiAxios.get('/timedTaskManager/checkCron', params, response);
    },
    // 任务日志策略查询
    getJobLogStoragePolicy(params, response) {
        return window.vue.$apiAxios.postRequestBody('/timeTaskJobLogStoragePolicy/getJobLogStoragePolicy', params, response);
    },
    // 任务日志策略保存
    saveJobLogStoragePolicy(params, response) {
        return window.vue.$apiAxios.postRequestBody('/timeTaskJobLogStoragePolicy/saveJobLogStoragePolicy', params, response);
    }
};
